import { useEffect, useState } from 'react'

/**
 * Hora actual (ms) que se actualiza cada `intervalo` ms.
 * Sirve para mostrar tiempos transcurridos ("hace 5 min") sin recalcular en cada render.
 */
export const useAhora = (intervalo = 30_000) => {
  const [ahora, setAhora] = useState(() => Date.now())
  useEffect(() => {
    const id = window.setInterval(() => setAhora(Date.now()), intervalo)
    return () => window.clearInterval(id)
  }, [intervalo])
  return ahora
}
